module.exports = __webpack_public_path__ + "img/depmap_svg_V170.96e255b1.svg";